import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';
import { IDocsPayload, IDocsResponse, IDocTypeListResponse } from '../../models/documents-check';

@Injectable({
	providedIn: 'root',
})
export class DocsService extends ApiService {
	constructor() {
		super();
	}

	public sendDocsResult(body: IDocsPayload): Observable<IDocsResponse> {
		return this.http.post<IDocsResponse>(environment.identity2 + `/documents`, body, {
			headers: this.getHeaders(),
		});
	}

	/**
	 * Envía el resultado de documentos usando FormData.
	 *
	 * @param formData FormData que contiene los archivos y datos del documento.
	 * @returns Observable con la respuesta del servidor.
	 */
	public sendDocsResultFormData(formData: FormData): Observable<IDocsResponse> {
		// Para FormData, eliminar Content-Type para que el navegador
		// establezca automáticamente el boundary correcto
		const headers = this.getHeaders();
		delete headers['Content-Type'];

		return this.http.post<IDocsResponse>(environment.identity2 + `/documents`, formData, {
			headers: headers,
		});
	}

	public getDocsTypeList(): Observable<IDocTypeListResponse> {
		return this.http.get<IDocTypeListResponse>(environment.identity2 + `/documents/type/list`, {
			headers: this.getHeaders(),
		});
	}

	/**
	 * Envía el CSV de referencia IRPF (CVE). El componente arma un FormData con `csv` y `uuid_config`;
	 * aquí se normaliza a JSON body para el endpoint.
	 */
	public sendIrpfCve(formData: FormData): Observable<any> {
		const body = {
			csv: String(formData.get('csv') ?? ''),
			uuid_config: String(formData.get('uuid_config') ?? ''),
		};
		return this.http.post<any>(environment.identity2 + `/documents/irpf/csv`, body, {
			headers: this.getHeaders(),
		});
	}
}
